import { render, staticRenderFns } from "./ScoreRecordsModal.vue?vue&type=template&id=163b8d27&scoped=true"
import script from "./ScoreRecordsModal.vue?vue&type=script&lang=js"
export * from "./ScoreRecordsModal.vue?vue&type=script&lang=js"
import style0 from "./ScoreRecordsModal.vue?vue&type=style&index=0&id=163b8d27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b8d27",
  null
  
)

export default component.exports